
import Msg from 'vux/src/components/msg/index.vue'

import { LANG } from '@/constants/lang'

export default{
components: {
Msg
},
mounted () {
this.setLocale()
},
methods: {
setLocale () {
this.$models.Deposit.ip().then(({data}) => {
const lang = LANG[data.data.locale_id]

if (!localStorage.getItem('lang')) {
localStorage.setItem('lang', lang)
this.$i18n.locale = lang
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/Finished.vue